/**
 * <look-info-modal> — the "Görüntüle" popup on the Birlikte Al row.
 *
 * quick-view-modal with two things pointed somewhere else: the section it
 * fetches and the template it reads out of the response. Everything else —
 * fetching, focus trapping, the transitions, moving itself to <body> — is
 * inherited, so a fix to the quick view lands here too.
 *
 * Defined behind customElements.whenDefined rather than at load, because the
 * class it extends is not reliably there yet. `defer` only orders scripts the
 * PARSER inserted; product-recommendations.js re-inserts this block's markup
 * (script tag and all) after a fetch, and a script inserted that way runs as
 * soon as it arrives — which was before theme.liquid's deferred quick-view.js,
 * so extending it at load silently left the popup undefined and every
 * "Görüntüle" fell through to a page navigation.
 *
 * Elements already in the DOM upgrade when the definition lands, and an
 * upgrade runs connectedCallback, so the triggers still get bound.
 */
customElements.whenDefined('quick-view-modal').then(() => {
  if (customElements.get('look-info-modal')) return;

  customElements.define(
    'look-info-modal',
    class LookInfoModal extends customElements.get('quick-view-modal') {
      get sourceSelector() {
        return '#MainProduct-look-info__content';
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.LookInfoSectionId || false;

        if (!sectionId) {
          const lookInfo = document.querySelector('.section-group-overlay-look-info');
          if (lookInfo) {
            sectionId = FoxTheme.utils.getSectionId(lookInfo);
          }

          FoxTheme.LookInfoSectionId = sectionId;
        }

        return sectionId;
      }
    }
  );
});
